import React from 'react';
import AppImage from '@/components/ui/AppImage';

interface HeroSectionProps {
  title: string;
  subtitle: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  description,
  imageSrc,
  imageAlt,
}) => {
  return (
    <section className="relative bg-gradient-to-br from-primary/10 via-background to-secondary/10 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6 animate-fade-in">
            <div className="inline-block px-4 py-2 bg-accent/20 rounded-full">
              <span className="text-sm font-cta font-bold text-accent-foreground uppercase tracking-wide">
                {subtitle}
              </span>
            </div>
            <h1 className="text-4xl lg:text-6xl font-headline font-bold text-foreground leading-tight">
              {title}
            </h1>
            <p className="text-lg lg:text-xl font-body text-muted-foreground leading-relaxed">
              {description}
            </p>
          </div>
          <div className="relative h-[400px] lg:h-[500px] rounded-2xl overflow-hidden shadow-lg animate-fade-in">
            <AppImage
              src={imageSrc}
              alt={imageAlt}
              fill
              className="object-cover"
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;